import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import LoadingScreen from '@/components/layout/LoadingScreen';
import NotFoundPage from '@/pages/NotFoundPage';

const AdminRoute = ({ children }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (profile?.role !== 'Admin') {
    return <NotFoundPage />;
  }

  return children;
};

export default AdminRoute;